/* lua.js generated code 0.3.0 */

PanelBounceAnim = {}
PanelBounceAnim.popup = function (basePanel, time, centerPos, fromScale, callback, anchorCenter) {
    // cc.log(basePanel, basePanel.nodeExist)
    var size = basePanel.getContentSize()
    if (anchorCenter)
    {
        size =  new cc.Size(0,0)
    }
    var targetScale = basePanel.getScale()
    var oneScalePos = cc.p(centerPos.x - size.width / 2, centerPos.y + size.height / 2)
    var fromPos = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), fromScale))
    var targetPos = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), targetScale))
    var midPoint = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), targetScale * 1.16))
    basePanel.setScale(fromScale)
    basePanel.setPosition(fromPos)
    basePanel.runAction(
        cc.Sequence.create(
            cc.Spawn.create(
                cc.EaseSineOut.create(
                    cc.ScaleTo.create(time * 2 / 3, targetScale * 1.16)
                ),
                cc.EaseSineOut.create(cc.MoveTo.create(time * 2 / 3, midPoint))
            ), cc.Spawn.create(
                cc.EaseSineIn.create(cc.ScaleTo.create(time / 3, targetScale)),
                cc.EaseSineIn.create(cc.MoveTo.create(time / 3, targetPos))
            ), cc.CallFunc.create(function () {
                if (callback) {
                    callback()
                }
            })))
}
PanelBounceAnim.remove = function (basePanel, time, centerPos, callback) {
    if (!basePanel || !basePanel.nodeExist) {
        return
    }
    var size = basePanel.getContentSize()
    var fromScale = basePanel.getScale()
    var oneScalePos = cc.p(centerPos.x - size.width / 2, centerPos.y + size.height / 2)
    var midPoint = cc.pAdd(centerPos, cc.pMul(cc.pSub(oneScalePos, centerPos), fromScale * 1.16))
    basePanel.runAction(cc.Sequence.create(cc.Spawn.create(cc.EaseSineOut.create(cc.ScaleTo.create(time / 3, fromScale * 1.16)), cc.EaseSineOut.create(cc.MoveTo.create(time / 3, midPoint))), cc.Spawn.create(cc.EaseSineIn.create(cc.ScaleTo.create(time * 2 / 3, 0)), cc.EaseSineIn.create(cc.MoveTo.create(time * 2 / 3, centerPos))), cc.CallFunc.create(function () {
        if (callback) {
            callback()
        }
    })))
}
const frameTime = 1 / 30;
//适用于全屏活动
PanelBounceAnim.popup1 = function (basePanel, time, centerPos, fromScale, callback, anchorCenter) {
    var size = basePanel.getContentSize()
    if (anchorCenter)
    {
        size =  new cc.Size(0,0)
    }

    var targetScale = basePanel.getScale()
    var oneScalePos = cc.p(centerPos.x - size.width / 2, centerPos.y + size.height / 2)
    basePanel.setScale(1.04 * targetScale);
    basePanel.setPosition(oneScalePos)
    basePanel.runAction(cc.Sequence.create(
        cc.EaseInOut.create(cc.ScaleTo.create(frameTime * 3, targetScale * 0.99), 1),
        cc.EaseInOut.create(cc.ScaleTo.create(frameTime * 3, targetScale), 1),
        cc.CallFunc.create(function () {
            callback && callback();
        })
    ));
}

PanelBounceAnim.remove1 = function(basePanel, callback) {
    if (!basePanel || !basePanel.nodeExist) {
        return
    }
    basePanel.setScale(0);
    callback && callback();
}
